import React, { useState } from "react";
import { createPortal } from "react-dom";

export default function NumPicker({ children }) {
    const [pos, setPos] = useState(null);

    const show = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPos({
            left: rect.left + rect.width / 2,
            top: rect.top
        });
    };

    const hide = () => {
        setPos(null);
    };

    return (
        <>
            <div
                onMouseEnter={show}
                onMouseLeave={hide}
                style={{ display: "inline-block", cursor: "help" }}
            >
                {children}
            </div>

            {pos && createPortal(
                <div
                    style={{
                        position: "fixed",
                        left: pos.left,
                        top: pos.top,
                        transform: "translate(-50%, -100%)",
                        background: "#333",
                        color: "#fff",
                        padding: "10px",
                        borderRadius: "6px",
                        zIndex: 9999
                    }}
                >
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            alert("hi");
                        }}
                    >
                        Click me
                    </a>
                </div>,
                document.getElementById("numpicker")
            )}
        </>
    );
}